
import { useMetaTags } from '@/hooks/useMetaTags';
import ScreenPasswordGate from '@/components/ScreenPasswordGate';
import { Ranking } from "@/components/Ranking"
import { useTranslation } from '@/hooks/useTranslation';

export const LosMasVotados = () => {
  const { t } = useTranslation();

  useMetaTags({
    title: t('topVotedMetaTitle'),
    pathname: '/los-mas-votados'
  });


  return (
    <ScreenPasswordGate scope="top-voted">
      <div className="min-h-screen bg-black text-white">
        <div className="max-w-2xl mx-auto px-4 py-8">


          {/* Leaderboard */}

          <Ranking />

          {/* Admin Breadcrumb removed as requested */}
        </div>
      </div>
    </ScreenPasswordGate>
  );
};

export default LosMasVotados;